export const EMPLOYEE_GROUP_FIELD = 'EmployeeGroup'
export const EMPLOYEE_NUMBER_FIELD = 'EmployeeNumber'
export const DNI_FIELD = 'Dni'
export const BIRTHDATE_FIELD = 'Birthdate'

export default {
	EMPLOYEE_GROUP_FIELD,
	EMPLOYEE_NUMBER_FIELD,
	DNI_FIELD,
	BIRTHDATE_FIELD
}


// WEBPACK FOOTER //
// ./src/constants/loginRequiredFields.js